import { render, staticRenderFns } from "./hand.vue?vue&type=template&id=02af7da7&scoped=true&"
import script from "./hand.vue?vue&type=script&lang=js&"
export * from "./hand.vue?vue&type=script&lang=js&"
import style0 from "./hand.vue?vue&type=style&index=0&id=02af7da7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02af7da7",
  null
  
)

export default component.exports